var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('img',{attrs:{"src":require("@/assets/Logo_Colour_PNG_White.png"),"alt":"RenderThat","id":"logo"}}),(_vm.enableSpinner)?_c('spinner',{attrs:{"id":"spinner"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }